import styled from "@emotion/styled";
import * as React from "react";

const StyledLightText = styled.span`
  display: inline-block;
  color: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.theme.primaryColor60
  };
  padding-left: 3px;
`;

interface ILightTextProps {
  className?: string;
  children: React.ReactNode;
}

export const LightText: React.FC<ILightTextProps> = props => (
  <StyledLightText className={props.className}>{props.children}</StyledLightText>
);
